import React from "react";
import { PostModel } from "../../features/post/postTypes";
import "./Posts.css";
import { Link } from "react-router-dom";
import { Card, Row, Col, Image } from "react-bootstrap";

type Props = {
  post: PostModel;
};

const PostListItem = ({ post }: Props) => {
  const date = new Date(post.posted_at);
  const formattedDate = date.toLocaleDateString("pl-PL");

  return (
      <Card bg="secondary" className="mb-2 card mt-2 col-md-4 flex-nowrap">
        <Card.Body className="p-0">
          <Row>
            <Col lg>
              <Image
                  src={post.thumbnail || "/img/placeholder.png"}
                  alt="Thumbnail"
                  className="post-thumb"
                  onError={e => (e.currentTarget.src = "/img/placeholder.png")}
              />
            </Col>
            <Col className="p-2 main-col align-items-center">
              <Row>
                <Col>
                  <div className="d-flex align-items-top upper-content">
                    <h4 className="d-inline-block m-0 font-style-bold main-text">
                      {post.title}
                    </h4>
                    <h5 className="ml-auto">{formattedDate}</h5>
                  </div>
                </Col>
              </Row>
              <Card.Text
                  dangerouslySetInnerHTML={{ __html: post.lead }}
                  className="description-text"
              />
              <Link
                  to={`/post/${post.slug}`}
                  className="nav-link text-decoration-none link-white"
              >
                READ MORE
              </Link>
            </Col>
          </Row>
        </Card.Body>
      </Card>
  );
};

export default PostListItem;
